module.exports = __webpack_public_path__ + "tile-3-image-cU1oZE8.webp";